import React, { useContext } from 'react';

import { Formik, Field } from 'formik';

import { useLayoutContext } from '@contexts/LayoutContext';
import { UserContext } from '@contexts/UserContext';

import { useEditPlaylist } from '@hooks/API/Contact/UseContactPlaylists';
import { useEditPackagePlaylist } from '@hooks/API/Packages/UsePackagePlaylist';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import { NWInput, NWPrivacyLevelSelector, NWTextAreaCharCounter } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const PlayListInfoForm = ({ playlist, packageID, onUpdatePlaylists, onTouchForm, onClose }) => {
    const { currentUser } = useContext(UserContext);
    const { isMobile } = useLayoutContext();

    // Su mobile 12 righe di description occupano l'intera schermata: il form
    // deve restare leggibile senza scorrere fino ai pulsanti.
    const descriptionAutoSize = isMobile ? { minRows: 3, maxRows: 6 } : { minRows: 12, maxRows: 20 };

    const { mutateAsync: editPlaylist } = useEditPlaylist();
    const { mutateAsync: editPackagePlaylist } = useEditPackagePlaylist();
    const initialValues = {
        Name: '',
        Description: '',
        PrivacyLevel: 'Public',
        Published: false,
    };

    if (playlist) {
        initialValues.Name = playlist.Name;
        initialValues.Description = playlist.Description || '';
        initialValues.Published = playlist.IsPublished;
        initialValues.PrivacyLevel = playlist.PrivacyLevelName;
    }

    const bookIsMine = () => {
        if (!playlist || playlist.UserCreated === currentUser.UserID) {
            return true;
        }
        return false;
    };

    const handleSavePlayList = async (values, setSubmitting) => {
        setSubmitting(true);

        try {
            if (packageID) {
                // Le package playlist espongono solo il rename: niente Description/PrivacyLevel.
                const updatedPlaylist = {
                    ID: playlist.ID,
                    Name: values.Name,
                };
                await editPackagePlaylist({ playlist: updatedPlaylist });
                onTouchForm(false);
                onClose();
                if (onUpdatePlaylists) {
                    onUpdatePlaylists(updatedPlaylist);
                }
            } else {
                const updatedPlaylist = {
                    ID: playlist.ID,
                    Name: values.Name,
                    Description: values.Description,
                    PrivacyLevel: values.PrivacyLevel,
                    IsPublished: initialValues.Published,
                    Type: 'Book',
                };

                if (playlist) {
                    updatedPlaylist.ContactID = playlist.ContactID;
                } else {
                    updatedPlaylist.CompCard = values.CompCard;
                }

                await editPlaylist({ playlist: updatedPlaylist, contactID: playlist && playlist.ContactID });
                onTouchForm(false);
                onClose();
                if (onUpdatePlaylists) {
                    onUpdatePlaylists(updatedPlaylist);
                }
            }
            setSubmitting(false);
        } catch (error) {
            console.error('error => ', error);
            setSubmitting(false);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
                handleSavePlayList(values, setSubmitting);
            }}
        >
            {({ isSubmitting, values, handleSubmit }) => (
                <NwForm values={values} onTouchForm={onTouchForm} onFinish={handleSubmit} layout="vertical">
                    <Field component={NWInput} label="Name" name="Name" type="text" value={values.Name} />
                    {!packageID && (
                        <Field
                            component={NWTextAreaCharCounter}
                            label="Description"
                            name="Description"
                            value={values.Description}
                            maxLength={2000}
                            autoSize={descriptionAutoSize}
                            type="text"
                            id="Description"
                        />
                    )}
                    {!packageID && bookIsMine() && (
                        <Field
                            component={NWPrivacyLevelSelector}
                            label="Privacy Level"
                            name="PrivacyLevel"
                            value={values.PrivacyLevel}
                        />
                    )}
                    <br />
                    <br />
                    <NwFormButtonsBar
                        left={
                            <NwCancelButton
                                disabled={isSubmitting}
                                onClick={() => {
                                    onTouchForm(false);
                                    onClose();
                                }}
                            />
                        }
                        right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                    />
                </NwForm>
            )}
        </Formik>
    );
};

export default PlayListInfoForm;
